import CatalogTracker from "./catalog-tracker.js";

export default CatalogTracker;
